module.exports = __webpack_public_path__ + "img/yl_01.e2110525.png";